import { useEffect, useState } from 'react';

import { updateStatus } from '../api/services/Auth';
import { useToast } from '../contexts/ToastContext';

import { useWebSocket } from './useWebSocket';

interface IUseUpdateStatus {
  userState: User;
  employeesState: Employee[];
  handleUpdateUserStatus: (employeeId, status) => void;
  isLoading: boolean;
}

export const useUpdateStatus = (currentUser, currentEmployees): IUseUpdateStatus => {
  const [userState, updateUserState] = useState<User>(currentUser);
  const [employeesState, updateEmployeesState] = useState(currentEmployees);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { addToast } = useToast();

  const srsTopic = 'srs_availabilities';
  const { lastJsonMessage: srsStatusChange } = useWebSocket({ topic: srsTopic });

  useEffect(() => {
    if (currentEmployees.length) {
      updateEmployeesState(currentEmployees);
    }
  }, [currentEmployees]);

  useEffect(() => {
    if (srsStatusChange && srsStatusChange.topic === srsTopic) {
      srsStatusChange.data.forEach((data) => {
        const { employeeId, status } = data.srsAvailabilities[0];

        updateEmployeeStatus(employeeId, status);
      });
    }
  }, [srsStatusChange]);

  const updateEmployeeStatus = (employeeId, status) => {
    // Check current user
    if (userState.id === employeeId) {
      updateUserState((prevState) => ({
        ...prevState,
        srsAvailability: {
          ...userState.srsAvailability,
          status: status,
        },
      }));
    }
    if (employeesState.length) {
      const results = employeesState.map((e: Employee) =>
        Object.assign(e, {
          srsAvailability: {
            ...e.srsAvailability,
            ...(e.id === employeeId && { status: status }),
          },
        })
      );

      updateEmployeesState(results);
    }
  };
  const handleUpdateUserStatus = async (employeeId, status) => {
    setIsLoading(true);
    const response = await updateStatus(employeeId, status);

    if (response.type === 'error') {
      response.error.errors.forEach((error) => addToast({ severity: 'error', message: error }));
    } else {
      updateEmployeeStatus(employeeId, status);
      addToast({ severity: 'success', message: response.data.message });
    }
    setIsLoading(false);
  };

  return {
    userState,
    employeesState,
    handleUpdateUserStatus,
    isLoading,
  };
};
